export const basePath = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : 'https://www.musicadjudicator.com/gtvss/public/'
// export const basePath = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : 'http://stagingapi.musicadjudicator.com/'



// WEBPACK FOOTER //
// ./src/helper/basePath.jsx